import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth token lives in an httpOnly cookie set by the backend on login —
// nothing sensitive is stored in JS-accessible storage.
export const authAxios = axios.create({ withCredentials: true });

export const downloadCv = async (uploadId, filename) => {
  const res = await authAxios.get(`${API}/admin/uploads/${uploadId}/cv`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'cv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const csvEscape = (v) => {
  const s = String(v ?? '');
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const downloadCsvFile = (rows, filename) => {
  const csv = rows.map(r => r.map(csvEscape).join(',')).join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
